const isTeacher = state => state.userRole === 'teacher'
const hasCheckedAccess = state => state.routerCheckedAccess

export default {
  isTeacher,
  hasCheckedAccess
}
